import React, { useEffect, useState } from "react";
import { ChevronRight, Upload, Eye, X, ChevronLeft } from "lucide-react";
import "../../styles/upload.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useRef } from "react";
import Firstphoto from "../../assets/uploadpage1.png";
import Scoundphoto from "../../assets/uploadpage2.png";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import {
  masterdata_create,
  masterdata_list,
  students_profile,
  institution_dashboard,
  batch_create,
  update_profile,
  masterdata_update,
  user_exams_add,
} from "../../util/Apiendpoits";
import {
  deleteWithTokenAPI,
  deleteWithTokenAPIpayload,
  getWithoutTokenAPI,
  getWithTokenAPI,
  ImageUpload,
  postWithoutTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../../util/Api";
import { FiBook, FiX } from "react-icons/fi";
import Select from "react-select";
import { SafeToast } from "../Toast/ShowToast";
import SelectDropdown from "../ReusableComponent/SelectDropdown";
import { setProfileData } from "../../store/profileSlice";

const UploadPage = () => {
  const location = useLocation();
  const [tab, setTab] = useState(() => {
    // if (location.state?.activeTab) {
    //     return location.state.activeTab;
    // }
    const saved = localStorage.getItem("uploadFormData");
    return saved ? "headline" : "headline";
  });
  const [totalQuestions, setTotalQuestions] = useState(() => {
    const saved = localStorage.getItem("totalQuestions");
    return saved ? parseInt(saved) : 0;
  });

  const [answers, setAnswers] = useState(() => {
    const saved = localStorage.getItem("omrAnswers");
    return saved ? JSON.parse(saved) : {};
  });

  const navigate = useNavigate();
  const profile = useSelector((state) => state.profile);
  const { token, roleType, userId } = useSelector((state) => state.auth);
  const [examOptions, setExamOptions] = useState([]);
  const [allexamOptions, setAllExamOptions] = useState([]);

  const [allSubexamOptions, setSubAllExamOptions] = useState([]);
  const [subExamOptions, setSubExamOptions] = useState([]);
  const [Institutionprofile, setInstitutionprofile] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [showAddInput, setShowAddInput] = useState(false);
  const [newExamValue, setNewExamValue] = useState("");
  const dispatch = useDispatch();
  const [examName, setExamName] = useState("");
  const isExam = examName?.toLowerCase().trim() === "exam";
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(() => {
    const savedFormData = localStorage.getItem("uploadFormData");
    if (savedFormData) {
      return JSON.parse(savedFormData);
    }
    return {
      headlineTagline: "",
      bannerTagline: "",
      testFees: "",
      testBatchName: "",
      subTopic: "",
      syllabus: "",
      schedulePdf: "",
      testNo: "1",
      questionPdf: "",
      answerPdf: "",
      videoLink: "",
      omrsheet: "",
      examduration: ""
    };
  });

  console.log(formData, 'formData')
  const getParsedItem = (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (err) {
      console.warn(`Invalid JSON in localStorage for ${key}`);
      localStorage.removeItem(key); // cleanup bad data
      return null;
    }
  };

  const [activeExam, setActiveExam] = useState(() =>
    getParsedItem("activeExam"),
  );

  console.log(activeExam, 'activeExamactiveExamactiveExam')
  const [activeSubExam, setActiveSubExam] = useState(() =>
    getParsedItem("activeSubExam"),
  );
  console.log(activeSubExam, 'activeSubExamactiveSubExamactiveSubExam')


  useEffect(() => { }, [profile]);
  useEffect(() => {
    if (activeExam !== null) {
      localStorage.setItem("activeExam", JSON.stringify(activeExam));
    }
  }, [activeExam]);

  useEffect(() => {
    if (activeSubExam !== null) {
      localStorage.setItem("activeSubExam", JSON.stringify(activeSubExam));
    }
  }, [activeSubExam]);

  // Dashboard stats
  const [dashboardStats, setDashboardStats] = useState({
    totalStudents: 0,
    totalBatches: 0,
  });

  const [loading, setLoading] = useState(false);
  const tabsRef = useRef(null);
  const ExamtabsRef = useRef(null);

  const fetchExamOptions = async () => {
    try {
      const response = await getWithoutTokenAPI(masterdata_list);

      if (response.statusCode === 200) {
        const options = response.data
          .filter(
            (item) => item.type === "examType" && item.status === "active",
          )
          .map((item) => ({
            value: item.code,
            label: item.value,
            id: item._id,
          }));
        setAllExamOptions(options);

        const Suboptions = response.data
          .filter(
            (item) => item.type === "subexamType" && item.status === "active",
          )
          .map((item) => ({
            value: item.code,
            label: item.value,
            id: item._id,
          }));
        setSubAllExamOptions(Suboptions);
      }
    } catch (error) {
      console.error("Error fetching exam options:", error);
    }
  };

  useEffect(() => {
    fetchExamOptions();
  }, []);

  useEffect(() => {
    localStorage.setItem("uploadFormData", JSON.stringify(formData));
  }, [formData]);

  // Save total questions to localStorage
  useEffect(() => {
    localStorage.setItem("totalQuestions", totalQuestions);
  }, [totalQuestions]);

  // Save answers to localStorage
  useEffect(() => {
    localStorage.setItem("omrAnswers", JSON.stringify(answers));
  }, [answers]);

  // Fetch institution profile
  useEffect(() => {
    if (roleType !== "institution_admin") return;
    const fetchProfile = async () => {
      try {
        const updateRes = await getWithTokenAPI(
          token,
          `${students_profile}${userId}`,
        );

        if (updateRes?.statusCode === 200) {
          setInstitutionprofile(updateRes.data);
        }
      } catch (error) {
        console.log("Failed to load institution profile");
        SafeToast.error("Failed to load profile");
      }
    };

    fetchProfile();
  }, [roleType, token, userId]);

  const fetchUserExams = async () => {
    try {
      const response = await getWithTokenAPI(token, `/user/${userId}/exams`);

      if (response?.statusCode === 200) {
        const examOpts = response.data.exams.map((exam) => ({
          value: exam._id,
          label: exam.value,
          code: exam.code,
          id: exam._id,
        }));
        setExamOptions(examOpts);

        const subExamOpts = response.data.subexams.map((subexam) => ({
          value: subexam._id,
          label: subexam.value,
          parentCode: subexam.code,
          id: subexam._id,
        }));
        setSubExamOptions(subExamOpts);
      }
    } catch (error) {
      console.error("Error fetching user exams:", error);
      SafeToast.error("Failed to load exams");
    }
  };
  useEffect(() => {
    if (!userId) return;
    fetchUserExams();
  }, [userId, token]);

  // Fetch dashboard statistics
  const fetchDashboardStats = async () => {
    try {
      const response = await getWithTokenAPI(
        token,
        `${institution_dashboard}${userId}`,
      );

      if (response?.success) {
        setDashboardStats({
          totalStudents: response.data?.totalStudents || 0,
          totalBatches: response.data?.totalBatches || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
      SafeToast.error("Failed to load dashboard statistics");
    }
  };
  useEffect(() => {
    if (roleType !== "institution_admin" || !userId) return;

    fetchDashboardStats();
  }, [roleType, token, userId]);

  const handleAddExam = async () => {
    if (!newExamValue) {
      SafeToast.success("Exams Updated successfully!");
      setShowAddInput(false);
      setOpenDialog(false);
      return null;
    }
    const newExam = {
      code:
        examName === "exam" ? allSubexamOptions.length + 1 : activeExam.code,
      value: newExamValue,
      type: examName === "exam" ? "examType" : "subexamType",
      status: "active",
    };

    try {
      const response = await postWithoutTokenAPI(masterdata_create, newExam);
      if (response.statusCode === 200 || response.statusCode === 201) {
        const option = {
          value: response.data?._id || newExam.code,
          label: newExam.value,
          code: newExam.code,
        };
        fetchExamOptions();
        if (examName == "exam") {
          setAllExamOptions((prev) => [...prev, option]);
        } else {
          setSubExamOptions((prev) => {
            const relatedSubs = prev.filter(
              (sub) => sub.parentCode === activeExam.code,
            );
            const exists = relatedSubs.some(
              (sub) => sub.value === option.value,
            );

            if (exists) {
              return prev.filter((sub) => sub.value !== option.value);
            } else {
              const newOption = {
                ...option,
                parentCode: activeExam.code,
              };

              return [...prev, newOption];
            }
          });
        }

        setNewExamValue("");
        setShowAddInput(false);
        SafeToast.success("New exam added successfully!");
      }
    } catch (error) {
      console.error("Error creating new exam:", error);
      SafeToast.error("Failed to add new exam");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
  };

  const uploadFile = async (type, file) => {
    // const MAX_SIZE = 50 * 1024 * 1024; 

    // if (file.size > MAX_SIZE) {
    //   SafeToast.error("Maximum allowed PDF size is 45 MB");
    //   return null;
    // }
    const formData = new FormData();
    formData.append("files", file);

    try {
      const response = await ImageUpload(
        `/upload_image?userId=${userId}&type=${roleType}`,
        formData,
        true,
      );
      if (response.statusCode === 413) {
        SafeToast.error("Maximum allowed PDF size is 45 MB");
      }
      if (response.statusCode === 200) {
        return response?.data?.[0]?.fileUrl || null;
      }

    }
    catch (error) {
      SafeToast.error("Maximum allowed PDF size is 45 MB");
      return null;
    }
  };

  const handleFileUpload = async (fileType, file) => {
    const fileUrl = await uploadFile(fileType, file);

    if (!fileUrl) return;

    setFormData((prev) => ({
      ...prev,
      [fileType]: {
        name: file.name,
        url: fileUrl,
      },
    }));

     setErrors((prev) => {
    const updatedErrors = { ...prev };
    delete updatedErrors[fileType];
    return updatedErrors;
  });

    SafeToast.success(
      `${fileType.replace(/([A-Z])/g, " $1")} uploaded successfully`,
    );
  };

  const handleExamClick = (exam) => {
    setActiveExam(exam);

    const related = subExamOptions.filter(
      (sub) => sub.parentCode === exam.code,
    );

    setActiveSubExam((prev) =>
      related.some((s) => s.id === prev?.id) ? prev : related[0] || null,
    );
  };

  const handleSubExamClick = (subExam) => {
    setActiveSubExam(subExam);
  };

  const handlePublish = async () => {
    // Validate required fields
    if (!activeExam || !activeExam.value) {
      SafeToast.error("Please select Exam");
      return;
    }

    if (!activeSubExam || !activeSubExam.value) {
      SafeToast.error("Please select Sub Exam");
      return;
    }
    if (!formData.headlineTagline.trim()) {
      SafeToast.error("Please enter Headline Tagline");
      return;
    }

    if (!formData.testBatchName.trim()) {
      SafeToast.error("Please enter Test Batch Name");
      return;
    }

    if (!formData.questionPdf) {
      SafeToast.error("Please upload Question PDF");
      return;
    }

    if (!activeExam || !activeSubExam) {
      SafeToast.error("Please select both exam and sub-exam");
      return;
    }

    if (!Institutionprofile?._id) {
      SafeToast.error("Institution profile not found");
      return;
    }

    // Prepare answers array from OMR data
    const answersArray = Object.entries(answers)
      .filter(([_, value]) => value) // Filter out undefined/null answers
      .map(([questionNumber, correctAnswer]) => ({
        questionNumber: parseInt(questionNumber),
        correctAnswer,
      }));

    // Prepare batch data
    const batchData = {
      Institution_id: Institutionprofile._id,
      examType: activeExam.value,
      subexamType: activeSubExam.value,
      headlineTagline: formData.headlineTagline,
      bannerTagline: formData.bannerTagline,
      testFees: parseInt(formData.testFees) || 0,
      testBatchName: formData.testBatchName,
      subTopic: formData.subTopic,
      syllabus: formData.syllabus,
      schedulePdf: formData.schedulePdf.url,
      testNo: parseInt(formData.testNo) || 1,
      totalQuestions: parseInt(totalQuestions) || 0,
      questionFiles: {
        questionPdf: formData.questionPdf.url,
        answerPdf: formData.answerPdf,
        videoLink: formData.videoLink,
        answers: answersArray,
        omrsheet: formData.omrsheet?.url,
      },
      examduration: formData.examduration
    };

    setLoading(true);
    try {
      const response = await postWithTokenAPI(token, batch_create, batchData);

      if (response?.statusCode === 200 || response?.statusCode === 201) {
        SafeToast.success("Batch created successfully!");
        fetchDashboardStats();

        // Reset form and clear localStorage
        setFormData({
          headlineTagline: "",
          bannerTagline: "",
          testFees: "",
          testBatchName: "",
          subTopic: "",
          syllabus: "",
          schedulePdf: "",
          testNo: "1",
          questionPdf: "",
          answerPdf: "",
          videoLink: "",
          omrsheet: "",
          examduration: ""
        });
        setAnswers({});
        setTotalQuestions(0);
        setTab("headline");

        // Clear localStorage
        localStorage.removeItem("uploadFormData");
        localStorage.removeItem("omrAnswers");
        localStorage.removeItem("totalQuestions");

        // Refresh dashboard stats
        const statsResponse = await getWithTokenAPI(
          token,
          `${institution_dashboard}${userId}`,
        );
        if (statsResponse?.statusCode === 200) {
          setDashboardStats({
            totalStudents: statsResponse.data?.totalStudents || 0,
            totalBatches: statsResponse.data?.totalBatches || 0,
          });
        }
      } else {
        SafeToast.error(response?.message || "Failed to create batch");
      }
    } catch (error) {
      console.error("Error creating batch:", error);
      SafeToast.error("An error occurred while creating the batch");
    } finally {
      setLoading(false);
    }
  };

  const ExamscrollLeft = () => {
    if (ExamtabsRef.current) {
      ExamtabsRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const ExamscrollRight = () => {
    if (ExamtabsRef.current) {
      ExamtabsRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const scrollLeft = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const handleNavigateToOMR = () => {
    localStorage.setItem("uploadFormData", JSON.stringify(formData));
    localStorage.setItem("omrAnswers", JSON.stringify(answers));
    localStorage.setItem("totalQuestions", totalQuestions);
    navigate("/omr");
  };

  const isExamChecked = (exam) => {
    if (isExam) {
      return examOptions.some((ex) => ex.code === exam.value);
    } else {
      return subExamOptions.some(
        (sub) => (sub.id || sub.value) === (exam.id || exam.value),
      );
    }
  };


  const validateFields = () => {
    let newErrors = {};

    if (!formData.headlineTagline?.trim()) {
      newErrors.headlineTagline = "Heading Tagline is required";
    }

    if (!formData.bannerTagline?.trim()) {
      newErrors.bannerTagline = "Banner Tagline is required";
    }

    if (!formData.testFees) {
      newErrors.testFees = "Test Fees is required";
    }

    if (!formData.testBatchName?.trim()) {
      newErrors.testBatchName = "Batch Name is required";
    }

    if (!formData.examduration?.trim()) {
      newErrors.examduration = "Exam Duration is required";
    }

    if (!formData.schedulePdf) {
      newErrors.schedulePdf = "Schedule PDF is required";
    }

    if (!formData.subTopic?.trim()) {
      newErrors.subTopic = "Sub Topic is required";
    }

    if (!formData.syllabus?.trim()) {
      newErrors.syllabus = "Syllabus is required";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const updateMasterData = async (exam, payload) => {
    try {
      const res = await putWithTokenAPI(
        token,
        `${masterdata_update}${exam.id}`,
        payload,
      );
      if (res.statusCode === 200) {
        setSubExamOptions((prev) =>
          prev.map((item) =>
            item.value === exam.value ? { ...item, parentCode: "-0" } : item,
          ),
        );
      }
    } catch (error) {
      console.error("Masterdata update failed", error);
      throw error;
    }
  };

  const filteredSubExams = activeExam
    ? allSubexamOptions.filter((sub) => sub.value === activeExam.code)
    : [];
  console.log(filteredSubExams, "FILTEREDSUBEXAMS");

  const deleteUserExam = async ({ exams = [], subexams = [] }) => {
    if (!token || !userId) {
      console.warn("Missing token or userId");
      return;
    }

    if (!exams.length && !subexams.length) {
      console.warn("Nothing to delete");
      return;
    }

    try {
      const res = await deleteWithTokenAPIpayload(
        token,
        `/user/${userId}/exams-remove`,
        {
          exams,
          subexams,
        },
      );

      if (res?.statusCode === 200) {
        SafeToast.success("Removed successfully");
      } else {
        SafeToast.error(res?.message || "Remove failed");
      }
    } catch (error) {
      console.error("Delete exam error:", error);
      SafeToast.error("Delete failed");
    }
  };
  const getExamId = (exam) => exam?.id || exam?.value || null;


  const handleAddExamClick = async (exam) => {
    if (!exam) return;

    const examId = getExamId(exam);
    if (!examId) {
      console.warn("Invalid exam object", exam);
      return;
    }

    const examset = {
      id: examId,
      label: exam.label,
      value: examId,
    };

    if (isExam) {
      const exists = examOptions.some((ex) => ex.label === exam.label);

      if (exists) {
        // ✅ SAFE DELETE
        await deleteUserExam({
          exams: [examId],
          subexams: [],
        });

        setExamOptions((prev) => prev.filter((ex) => ex.label !== exam.label));
      } else {
        setExamOptions((prev) => [...prev, examset]);
        await handleSaveExam(examset);
      }
    } else {
      const exists = subExamOptions.some(
        (ex) => (ex.id || ex.value) === examId,
      );

      if (exists) {
        // ✅ SAFE DELETE
        await deleteUserExam({
          exams: [],
          subexams: [examId],
        });

        setSubExamOptions((prev) =>
          prev.filter((ex) => (ex.id || ex.value) !== examId),
        );
      } else {
        if (!activeExam?.code) {
          SafeToast.error("Select an exam first");
          return;
        }
        setSubExamOptions((prev) => [
          ...prev,
          {
            ...exam,
            parentCode: activeExam.code,
          },
        ]);
        await handleSaveExam(examset);
      }
    }
  };

  const handleSaveExam = async (exam) => {
    try {
      const payload = {
        [isExam ? "exams" : "subexams"]: [exam.id],
      };
      const res = await putWithTokenAPI(
        token,
        `${user_exams_add}/${userId}/exams-add`,
        payload,
      );

      if (res?.statusCode === 200) {
        SafeToast.success("Profile updated successfully");

        dispatch(
          setProfileData({
            name:
              roleType === "superadmin"
                ? res.data.name
                : res.data.nameofInstitution,
            phone: res.data.phoneNumber,
            role: res.data.roleType,
            price: res.data.adminPrice,
            profileImage: res.data.profile_img,
            logo: res.data.logo,
          }),
        );
        fetchUserExams();
      } else {
        SafeToast.error(res?.message || "Update failed");
      }
    } catch (error) {
      console.error("Update error:", error);
      SafeToast.error("Something went wrong");
    }
  };

  const handleOpenDialog = (name) => {
    console.log(name, "handleOpenDialog");
    setExamName(name);
    setOpenDialog(true);
  };


  const [focusedField, setFocusedField] = useState("");
  const handleRemovePdf = (field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: null
    }));
  };
  return (
    <div className="upload-page">
      <div className="stats-row">
        <div
          className="stat-card-upload student"
          style={{ backgroundImage: `url(${Firstphoto})` }}
        >
          <span className="stat-title">Total Students</span>
          <h2>{dashboardStats.totalStudents.toLocaleString()}</h2>
        </div>
        <div
          className="stat-card-upload batch"
          style={{ backgroundImage: `url(${Scoundphoto})`, cursor: "pointer" }}
          onClick={() => navigate("/batches")}
        >
          <span className="stat-title">Total Batches</span>
          <h2>{dashboardStats.totalBatches.toLocaleString()}</h2>
        </div>
      </div>

      <div className="exam-box">
        <div className="exam-header">
          <h4>Exams</h4>
          <div className="nav-arrows">
            <div className="add-btn-wrapper">
              <button
                className="add-btn"
                onClick={() => handleOpenDialog("exam")}
              >
                <span className="plus">+</span>
                <span className="text">Add</span>
              </button>
            </div>
            <button className="nav-btn" onClick={ExamscrollLeft}>
              <ChevronLeft size={18} />
            </button>
            <button className="nav-btn" onClick={ExamscrollRight}>
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        <div className="exam-tabs" ref={ExamtabsRef}>
          {examOptions.length > 0 ? (
            examOptions.map((exam) => (
              <button
                key={exam.id || exam.value}
                className={activeExam?.value === exam.value ? "active" : ""}
                onClick={() => handleExamClick(exam)}
              >
                {exam.label}
              </button>
            ))
          ) : (
            <div className="no-data-upload">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="no-data-upload-icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
                />
              </svg>
              <span>No exams found</span>
            </div>
          )}
        </div>
      </div>

      <div className="exam-box">
        <div className="exam-header">
          <h4> Sub Exams</h4>
          <div className="nav-arrows">
            <div className="add-btn-wrapper">
              <button
                className="add-btn"
                onClick={() => handleOpenDialog("subexam")}
              >
                <span className="plus">+</span>
                <span className="text">Add</span>
              </button>
            </div>
            <button className="nav-btn" onClick={scrollLeft}>
              <ChevronLeft size={18} />
            </button>
            <button className="nav-btn" onClick={scrollRight}>
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        <div className="exam-tabs" ref={tabsRef}>
          {subExamOptions.filter(
            (subExam) => subExam.parentCode === activeExam?.code,
          ).length > 0 ? (
            subExamOptions
              .filter((subExam) => subExam.parentCode === activeExam?.code)
              .map((subExam) => (
                <button
                  key={subExam.id || subExam.value}
                  className={
                    activeSubExam?.id === subExam.id ? "active" : ""
                  }
                  onClick={() => handleSubExamClick(subExam)}
                >
                  {subExam.label}
                </button>
              ))
          ) : (
            <div className="no-data-upload">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="no-data-upload-icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
                />
              </svg>
              <span>No data found</span>
            </div>
          )}
        </div>
      </div>

      <div className="main-card">
        <div className="card-tabs">
          <button
            className={tab === "headline" ? "active" : ""}
            onClick={() => setTab("headline")}
          >
            Headline
          </button>
          <button
            className={tab === "questions" ? "active" : ""}
            onClick={() => {
              if (validateFields()) {
                setTab("questions");
              }
            }}
          >
            Questions Upload
          </button>
        </div>

        <div className="card-body">
          {tab === "headline" ? (
            <div className="headline-content">
              <div className="row-3">
                <div>
                  <label>Heading Tagline :</label>
                  <input
                    name="headlineTagline"
                    value={formData.headlineTagline}
                    onChange={handleInputChange}
                    onFocus={() => setFocusedField("headlineTagline")}
                    onBlur={() => setFocusedField("")}
                    className={focusedField === "headlineTagline" ? "blue-btn" : ""}
                    style={{ width: "100%", textAlign: "left" }}
                    placeholder="Enter headline tagline"
                  />
                  {errors.headlineTagline && (
                    <p className="error-text">{errors.headlineTagline}</p>
                  )}
                </div>
                <div>
                  <label>Banner Tagline :</label>
                  <textarea
                    name="bannerTagline"
                    value={formData.bannerTagline}
                    onChange={handleInputChange}
                    onFocus={() => setFocusedField("bannerTagline")}
                    onBlur={() => setFocusedField("")}
                    className={focusedField === "bannerTagline" ? "blue-btn" : ""}
                    rows={2}
                    placeholder="Enter banner tagline"
                  />
                  {errors.bannerTagline && <p className="error-text">{errors.bannerTagline}</p>}
                </div>
                <div>
                  <label>Test Fees :</label>
                  <input
                    type="number"
                    name="testFees"
                    value={formData.testFees}
                    onChange={handleInputChange}
                    className="price-box"
                    placeholder="Enter Fee"
                  />
                  {errors.testFees && <p className="error-text">{errors.testFees}</p>}
                </div>
              </div>
              <div className="divider"></div>
              <div className="row-3">
                <div>
                  <label>Test Batch Name :</label>
                  <input
                    name="testBatchName"
                    value={formData.testBatchName}
                    onChange={handleInputChange}
                    placeholder="Enter test batch name"
                  />
                  {errors.testBatchName && <p className="error-text">{errors.testBatchName}</p>}
                </div>
                <div>
                  <label>Sub Topic :</label>
                  <input
                    name="subTopic"
                    value={formData.subTopic}
                    onChange={handleInputChange}
                    placeholder="Enter sub topic "
                  />
                  {errors.subTopic && (
                    <p className="error-text">{errors.subTopic}</p>
                  )}
                </div>
                <div>
                  <label>Exam Duration (Minutes):</label>
                  <input
                    name="examduration"
                    value={formData.examduration}
                    onChange={handleInputChange}
                    placeholder="Enter exam duration : "
                  />
                  {errors.examduration && <p className="error-text">{errors.examduration}</p>}
                </div>
                <div>
                  <label>Syllabus :</label>
                  <textarea
                    name="syllabus"
                    value={formData.syllabus}
                    onChange={handleInputChange}
                    placeholder="Enter syllabus"
                  />
                  {errors.syllabus && (
                    <p className="error-text">{errors.syllabus}</p>
                  )}
                </div>
              </div>
              <div className="footer-row">
                <div className="schedule-box">
                  <span>Schedule</span>
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={(e) =>
                      handleFileUpload("schedulePdf", e.target.files[0])
                    }
                    style={{ display: "none" }}
                    id="schedulePdf"
                  />
                  <label htmlFor="schedulePdf" className={formData.schedulePdf ? "uploaded-btn-small" : "upload-btn-small"} >
                    {formData.schedulePdf ? "Uploaded PDF" : "Upload PDF"}
                  </label>
                  {formData.schedulePdf && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                      <a
                        href={formData.schedulePdf.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pdf-link"
                      >
                        <span className="pdf-icon">📄</span>
                        <span className="pdf-name">
                          {formData.schedulePdf.name}
                        </span>
                      </a>

                      <button
                        onClick={() => handleRemovePdf("schedulePdf")}
                        style={{
                          border: "none",
                          background: "transparent",
                          cursor: "pointer",
                          fontSize: "18px",
                          color: "red"
                        }}
                      >
                        <IoClose />
                      </button>
                    </div>
                  )}
                  {errors.schedulePdf && <p className="error-text">{errors.schedulePdf}</p>}
                </div>
                <button
                  className="next-btn-upload"
                  onClick={() => {
                    if (validateFields()) {
                      setTab("questions");
                    }
                  }}
                >
                  Next <ChevronRight size={18} />
                </button>
              </div>

            </div>
          ) : (
            <div className="questions-content">
              <div className="question-top-row">
                <div>
                  <label>Test No :</label>

                  {/* <SelectDropdown
                                        value={formData.testNo}
                                        options={testNoOptions}
                                        placeholder="No"
                                        width="100px"
                                        onChange={(value) =>
                                            setFormData((prev) => ({
                                                ...prev,
                                                testNo: value,
                                            }))
                                        }
                                    /> */}

                  <div className="confirm-box">
                    <input
                      type="text"
                      value={formData.testNo}
                      style={{ width: "50px", textAlign: "center" }}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          testNo: e.target.value,
                        }))
                      }
                      min="1"
                    />
                  </div>
                </div>

                <div>
                  <label>Total Questions :</label>
                  <div className="confirm-box">
                    <input
                      type="number"
                      value={totalQuestions}
                      onChange={(e) => setTotalQuestions(e.target.value)}
                      min="1"
                    />
                  </div>
                </div>
                <div
                  className="upload-card"
                  style={{ width: "300px", height: "50px", marginTop: "20px" }}
                >
                  <span>OMR PDF</span>
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={(e) =>
                      handleFileUpload("omrsheet", e.target.files[0])
                    }
                    style={{ display: "none" }}
                    id="omrPdf"
                  />
                  <label htmlFor="omrPdf" className={formData.omrsheet ? "green-text-btn" : "blue-text-btn "}>
                    <Upload size={14} /> {formData.omrsheet ? "Uploaded " : "Upload"}
                  </label>
                </div>

                {formData.omrsheet && (
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                    <a
                      href={formData.omrsheet.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pdf-link"
                    >
                      <span className="pdf-icon">📄</span>
                      <span className="pdf-name">
                        {formData.omrsheet.name}
                      </span>
                    </a>

                    <button
                      onClick={() => handleRemovePdf("omrsheet")}
                      style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "red"
                      }}
                    >
                      <IoClose />
                    </button>
                  </div>
                )}
              </div>
              <div className="upload-row-upload">
                <div className="upload-card">
                  <span>Question PDF</span>
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={(e) =>
                      handleFileUpload("questionPdf", e.target.files[0])
                    }
                    style={{ display: "none" }}
                    id="questionPdf"
                  />
                  <label htmlFor="questionPdf" className={formData.questionPdf ? "green-text-btn" : "blue-text-btn "}>
                    <Upload size={14} />{formData.questionPdf ? "Uploaded" : "Upload "}
                  </label>
                </div>

                <div className="answer-card-container">
                  <div className="answer-card">
                    <button onClick={handleNavigateToOMR}>Answers</button>
                    <div className="eye-icon">
                      <Eye size={18} />
                    </div>
                  </div>
                </div>

                <div className="video-card">
                  <span className="video-label">Video Link :</span>
                  <input
                    type="text"
                    name="videoLink"
                    value={formData.videoLink}
                    onChange={handleInputChange}
                    className="video-url-input"
                    placeholder="Enter video link"
                  />
                </div>
              </div>
              {formData.questionPdf && (
                <div style={{ display: "flex", alignItems: "center", marginTop: "10px", gap: "10px" }}>
                  <a
                    href={formData.questionPdf.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pdf-link"
                  >
                    <span className="pdf-icon">📄</span>
                    <span className="pdf-name">{formData.questionPdf.name}</span>
                  </a>

                  <button
                    onClick={() => handleRemovePdf("questionPdf")}
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      fontSize: "18px",
                      color: "red"
                    }}
                  >
                    <IoClose />
                  </button>
                </div>
              )}

              <div className="publish-row">
                <button
                  className="publish-btn"
                  onClick={handlePublish}
                // disabled={loading || !activeExam || !activeSubExam}
                >
                  {loading ? "Publishing..." : "Publish"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {openDialog && (
        <div className="modal-overlay">
          <div className="crop-modal">
            <div className="modal-header">
              <h3> {isExam ? "Add New Exam" : "Add Sub New Exam"}</h3>
              <button
                className="close-modal"
                onClick={() => {
                  setShowAddInput(false);
                  setOpenDialog(false);
                }}
              >
                <FiX />
              </button>
            </div>
            <div className="modal-body-exam">
              {showAddInput && (
                <div className="input-box single">
                  <input
                    type="text"
                    value={newExamValue}
                    onChange={(e) => setNewExamValue(e.target.value)}
                    placeholder="Enter new exam"
                  />

                  <div className="add-btn-wrapper">
                    <button className="add-btn" onClick={() => handleAddExam()}>
                      <span className="plus">+</span>
                      <span className="text">Create</span>
                    </button>
                  </div>
                </div>
              )}
              <div
                className="exam-checkbox-list"
                style={{
                  display: isExam
                    ? allexamOptions.length > 0
                      ? "grid"
                      : "block"
                    : filteredSubExams.length > 0
                      ? "grid"
                      : "block",
                }}
              >
                {isExam ? (
                  allexamOptions.length > 0 ? (
                    allexamOptions.map((exam) => (
                      <label
                        key={exam.id || exam.value}
                        className="exam-checkbox-item"
                      >
                        <input
                          type="checkbox"
                          checked={isExamChecked(exam)}
                          onChange={() => handleAddExamClick(exam)}
                        />
                        <span className="check-label">{exam.label}</span>
                      </label>
                    ))
                  ) : (
                    <div className="no-data-upload">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="no-data-upload-icon"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
                        />
                      </svg>
                      <span>No exams found</span>
                    </div>
                  )
                ) : filteredSubExams.length > 0 ? (
                  filteredSubExams.map((exam) => {
                    const checked = isExamChecked(exam);
                    return (
                      <label
                        key={exam.id || exam.value}
                        className={`exam-checkbox-item ${checked ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddExamClick(exam);
                        }}
                      >
                        <span className="check-label">{exam.label}</span>
                        {checked && <span className="close-icon">✕</span>}
                      </label>
                    );
                  })
                ) : (
                  <div className="no-data-upload" style={{ width: "90%" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="no-data-upload-icon"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
                      />
                    </svg>
                    <span>No exams found</span>
                  </div>
                )}

                {!showAddInput && (
                  <div
                    className="exam-checkbox-item add-exam"
                    onClick={() => setShowAddInput(true)}
                  >
                    <span className="plus-icon">+</span>
                    <span className="check-label">Create</span>
                  </div>
                )}
              </div>
            </div>
            {/* {isExam && ( */}
            <div className="crop-actions">
              <button
                className="cancel-crop-btn"
                onClick={() => {
                  setShowAddInput(false);
                  setOpenDialog(false);
                }}
              >
                Cancel
              </button>
              <button
                className="apply-crop-btn"
                onClick={() => handleAddExam()}
              >
                Save
              </button>
            </div>
            {/* )} */}
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadPage;
